import { Injectable } from '@angular/core';
import { Geolocation, Coordinates, } from '@awesome-cordova-plugins/geolocation/ngx';
import { NativeGeocoder } from '@awesome-cordova-plugins/native-geocoder/ngx';
import { Platform } from '@ionic/angular';
/*
 Generated class for the GeolocationService provider.

 See https://angular.io/docs/ts/latest/guide/dependency-injection.html
 for more info on providers and Angular 2 DI.
 */
@Injectable()
export class GeolocationService {
    private lastLocation: Coordinates;

    constructor(platform: Platform, private geolocation: Geolocation) {
        platform.ready().then(() => {
            this.geolocation.getCurrentPosition().then(pos => {
                this.lastLocation = pos.coords;
            }, err => {

            });

            this.geolocation.watchPosition().pipe().subscribe((pos: any) => {
                this.lastLocation = pos.coords;
            }, err => { console.debug(err) });
        });
    }
    public getLatitude(): number {
        if (this.lastLocation) return this.lastLocation.latitude;
        else return null;
    }

    public getLongitude(): number {
        if (this.lastLocation) return this.lastLocation.longitude;
        else return null;
    }

    /**
     * Stop the geolocation watch
     */
    public stop() {
        // if(isPresent(this.watch) && !this.watch.isUnsubscribed)
        //     this.watch.unsubscribe();
    }

}

